import React, { useContext, useEffect, useRef, useState } from "react";
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Accordion, Nav, Navbar, Offcanvas } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import NavDropdown from "react-bootstrap/NavDropdown";
import Success_modal from "../common_components/common_modal/success_modal/Success_modal";
import User_login_modal from "../common_components/common_modal/user_login_modal/User_login_modal";
import { GetAllCountry } from "../features/website/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../utils/context";

function Header() {
  const [lang, setLang] = useState("en");

  const { language, setLanguage } = useContext(Context);

  console.log(language, "language");

  const dispatch = useDispatch();
  const country = useSelector(
    (state) => state?.website?.GetSuccessSpeaks?.all_country,
  );

  useEffect(() => {
    dispatch(GetAllCountry({ language }));
  }, [language, dispatch]);

  const location = useLocation();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const accordionRef = useRef(null);

  const [activeKey, setActiveKey] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        accordionRef.current &&
        !accordionRef.current.contains(event.target)
      ) {
        setActiveKey(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLinkClick = () => {
    handleClose();
    setActiveKey(null);
  };

  const applyLanguage = (langCode) => {
    let attempts = 0;

    const trySwitch = () => {
      if (window.Weglot?.switchTo) {
        window.Weglot.switchTo(langCode);
      } else if (attempts < 10) {
        attempts++;
        setTimeout(trySwitch, 200);
      }
    };

    trySwitch();
  };

  const toggleLanguage = () => {
    const newLang = lang === "en" ? "fr" : "en";

    setLang(newLang);
    setLanguage(newLang === "en" ? 1 : 2);
    localStorage.setItem("language", newLang);

    applyLanguage(newLang); // ✅ use retry function
  };

  const [ready, setReady] = useState(false);

  useEffect(() => {
    const savedLang = localStorage.getItem("language") || "fr";

    console.log(savedLang, "savedLang");

    setLang(savedLang);
    setLanguage(savedLang === "en" ? 1 : 2);

    applyLanguage(savedLang);

    setReady(true);
  }, []);

  if (!ready) return null;
  return (
    <>
      <section className="Header_holder">
        <Navbar
          expand="lg"
          className="header_nav"
          collapseOnSelect
          expanded={expanded}
          onToggle={() => setExpanded(!expanded)}
        >
          <Container>
            <div className="d-flex align-items-center">
              <Navbar.Brand as={Link} to={"/home"}>
                <div className="logo_holder">
                  <img
                    src="/assets/images/logo/Dark.png"
                    alt="logo"
                    className="logo_img"
                  />
                </div>
              </Navbar.Brand>
            </div>

            <Nav.Link>
              <div
                id="google_translate_element"
                style={{ display: "none" }}
              ></div>

              <div
                className="toggle_container mobtranslator"
                onClick={toggleLanguage}
              >
                <div
                  className={`toggle_slider ${lang === "fr" ? "right" : ""}`}
                >
                  {lang?.toUpperCase()}
                </div>
              </div>
            </Nav.Link>

            {/* Toggle visible only below 992px */}
            <Navbar.Toggle
              aria-controls="mobile-offcanvas"
              className="d-lg-none"
              onClick={handleShow}
            />

            <Navbar.Collapse id="navbarScroll" className="d-none d-lg-flex">
              <Nav className="ms-auto my-2 my-lg-0" navbarScroll>
                <Nav.Link
                  as={Link}
                  to="/home"
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/home" ? "active" : ""}
                >
                  {language == 1 ? "Home" : "Accueil"}
                </Nav.Link>

                <NavDropdown
                  title={language == 1 ? "Internships" : "Stages"}
                  id="navbarScrollingDropdown"
                >
                  {country?.data?.map((country) => (
                    <NavDropdown.Item
                      key={country.id}
                      as={Link}
                      to={`/internship/${country?.id}`}
                    >
                      {country?.Country_Lang?.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>

                <Nav.Link
                  as={Link}
                  to="/study-abroad"
                  onClick={() => setExpanded(false)}
                  className={
                    location.pathname === "/study-abroad" ? "active" : ""
                  }
                >
                  {language == 1 ? "Study Abroad" : "Étudier à l’étranger"}
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/about-us"
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/about-us" ? "active" : ""}
                >
                  {language == 1 ? "About Us" : "À propos de nous"}
                </Nav.Link>

                {/* <Nav.Link
                  as={Link}
                  to="/blogs"
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/blogs" ? "active" : ""}
                >
                  Blogs
                </Nav.Link> */}

                <Nav.Link
                  as={Link}
                  to="/contact-us"
                  onClick={() => setExpanded(false)}
                  className={
                    location.pathname === "/contact-us" ? "active" : ""
                  }
                >
                  {language == 1 ? "Contact Us" : "Contactez-nous"}
                </Nav.Link>

                <Nav.Link
                  href="https://afiway.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setExpanded(false)}
                >
                  {language == 1 ? "Portal" : "Portail"}
                </Nav.Link>

                <Nav.Link>
                  <div className="toggle_container" onClick={toggleLanguage}>
                    <div
                      className={`toggle_slider ${
                        lang === "fr" ? "right" : ""
                      }`}
                    >
                      {lang?.toUpperCase()}
                    </div>
                  </div>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>

            <Navbar.Offcanvas
              id="mobile-offcanvas"
              aria-labelledby="mobile-offcanvas"
              placement="start"
              className="d-lg-none mobile_view_offcanvas"
              show={show}
              onHide={handleClose}
            >
              <Offcanvas.Header closeButton />
              <Offcanvas.Body>
                <Nav className="me-auto" navbarScroll>
                  <Nav.Link
                    as={Link}
                    to="/home"
                    className={location.pathname === "/home" ? "active" : ""}
                    onClick={handleClose}
                  >
                    {language == 1 ? "Home" : "Accueil"}
                  </Nav.Link>

                  <Accordion
                    ref={accordionRef}
                    activeKey={activeKey}
                    onSelect={(key) => setActiveKey(key)}
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Internships</Accordion.Header>

                      <Accordion.Body>
                        {country?.data?.map((item) => (
                          <div key={item?.id} className="mb-2">
                            <Link
                              to={`/internship/${item?.id}`}
                              className={
                                location.pathname === `/internship/${item?.id}`
                                  ? "active"
                                  : ""
                              }
                              onClick={handleLinkClick}
                            >
                              {item?.name}
                            </Link>
                          </div>
                        ))}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <Nav.Link
                    as={Link}
                    to="/study-abroad"
                    className={
                      location.pathname === "/study-abroad" ? "active" : ""
                    }
                    onClick={handleClose}
                  >
                    {language == 1 ? "Study Abroad" : "Étudier à l’étranger"}
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    className={
                      location.pathname === "/about-us" ? "active" : ""
                    }
                    onClick={handleClose}
                  >
                    {language == 1 ? "About Us" : "À propos de nous"}
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/contact-us"
                    className={
                      location.pathname === "/contact-us" ? "active" : ""
                    }
                    onClick={handleClose}
                  >
                    {language == 1 ? "Contact Us" : "Contactez-nous"}
                  </Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </section>
    </>
  );
}

export default Header;
